import React from "react";
import "./Widgets.css";
import {
  TwitterTimelineEmbed,
  TwitterShareButton,
  TwitterTweetEmbed,
} from "react-twitter-embed";
import SearchIcon from "@material-ui/icons/Search";

function Widgets() {
  return (
    <div className="widgets">
      <div className="widgets__input">
        <SearchIcon className="widgets__searchIcon" />
        <input placeholder="Search Twitter" type="text" />
      </div>

      <div className="widgets__widgetContainer">
        <h2 >Stay Updated!</h2>
        <hr/>
        <br/>

        <TwitterTimelineEmbed className="bg"
          sourceType="profile"
          screenName="lpuuniversity"
          options={{ height: 800 }}
        />


<br/>
        <TwitterShareButton
          options={{ text: "Designed and Developed with ❤️ by @Chetan_LC and @dixit_kumawat"}}
        />
      </div>
    </div>
  );
}

export default Widgets;
